import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import clsx from 'clsx';
function _DetailVertCustom(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsx("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: _jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M12 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4m2-8a2 2 0 1 1-4 0 2 2 0 0 1 4 0m0-6a2 2 0 1 1-4 0 2 2 0 0 1 4 0", clipRule: "evenodd" }) }) });
}
const DetailVertCustom = forwardRef(_DetailVertCustom);
export { DetailVertCustom };
